// extracted by mini-css-extract-plugin
export default {"container":"MessagePage_container__Q4CJe","font-box":"MessagePage_font-box__4eS7i"};